export default "__VITE_ASSET__CPy29_eT__"